import { render, staticRenderFns } from "./downShield.vue?vue&type=template&id=9165b42e&scoped=true&"
import script from "./downShield.vue?vue&type=script&lang=js&"
export * from "./downShield.vue?vue&type=script&lang=js&"
import style0 from "./downShield.vue?vue&type=style&index=0&id=9165b42e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9165b42e",
  null
  
)

export default component.exports